// Wrapper for /accounts/:accountId/* routes. Nothing fancy yet — provides the
// account context to children. Once the IA redesign lands this is where the
// account-scoped sidebar / breadcrumb / context-aware header lives.
import { Outlet } from "react-router-dom";
import { AccountProvider } from "@/state/account";

export function AccountLayout() {
  return (
    <AccountProvider>
      <Outlet />
    </AccountProvider>
  );
}
